module.exports = __webpack_public_path__ + "static/img/logo.71366369.png";